import React from 'react';

const Institutional = ({ children }: any) => {
    return (
        <section className="institutional-page">
            {children}
        </section>
    );
};

export default Institutional;
